import { createContext, useContext } from 'react';

type DashboardTitleBarContext = {
  overrideDashboardTitleBar?(icon: string, title: string): void;
};
export const DashboardTitleBarContext = createContext<
  DashboardTitleBarContext | undefined
>(undefined);

export const { Provider: DashboardTitleBarContextProvider } =
  DashboardTitleBarContext;

export const useDashboardTitleBarContext = () => {
  const context = useContext(DashboardTitleBarContext);
  if (!context) {
    throw new Error(
      'useDashboardTitleBarContext must be used within an DashboardTitleBarContextProvider'
    );
  }
  return context;
};
